import { Component, ElementRef, Input, Output, EventEmitter, OnInit, AfterContentChecked } from '@angular/core';
import {NgStyle} from '@angular/common';

import { EventsService } from '../../shared/Events.service';
import { ElectionService } from '../../shared/election-service/election.service';
import { SettingsService } from '../../shared/settings/settings.service';
import { TranslateService} from 'ng2-translate/ng2-translate';

import Utilities from '../../utilities';

declare let componentHandler: any;

type votingLocationType = "polling-place" | "early-voting";

@Component({
    selector: 'early-voting-info',
    template: require('./earlyvoting.component.html')
})

export class EarlyVotingComponent implements OnInit, AfterContentChecked  {
    //Address variables
    selectedAddressLocation:Object;
    selectedFullAddress:string;

    //early voting location variables
    satelliteName: string;
    satelliteAddress: string;
    satelliteCity: string;
    satelliteSchedule: string;
    satelliteLocations: Array<Object>;
    activePhoto:string;

    isEarlyVotingRetrieved:boolean = false;
    isRedirectEnabled = true;
    tabActivated:boolean = false;
    error: any;
    appSettings: Object;

    //email
    toAddress:string;
    fromAddress:string; 
    emailSubject:string;
    emailBody:string;
    message:Object;
    showEmailPanel:boolean = false;

    private pollingPlaceInfo: Object;
    private selectedAddressSuggestion:Object;

    constructor(private elRef: ElementRef, private _eventsService: EventsService, public _electionService: ElectionService, private _settingsService: SettingsService, private _translate: TranslateService) {       
    }

    ngOnInit () {
        //subscribe to the selected address from the address search
        this._eventsService.selectedAddressObject$.subscribe(address => {
                //get the current address
                this.selectedAddressSuggestion = address["addressSuggestion"];
                //Get the current address location
                this.selectedAddressLocation = address["addressLocation"];  
            }
        ); 

        //subscribe to the search invoked event, once a search is begun
        this. _eventsService.searchInvoked$.subscribe(
            address => {
                //get the current address
                this.selectedAddressSuggestion = address["addressSuggestion"];
                //Get the current address location
                this.selectedAddressLocation = address["addressLocation"];  
                this.isEarlyVotingRetrieved = false;
                this.selectedAddressLocation ? this.getEarlyVotingInformation() : console.log("Address location is undefined");
            }
        );

        // Get app settings from settings service      
        this._settingsService.getAppSettings().subscribe(
            settings => { 
                this.appSettings = settings[0];
                let currentTabSettings:Object = this.appSettings["widgets"].filter(item => { return item.name === 'EarlyVoting'; });
                this.tabActivated = currentTabSettings[0].activate;
            },
            err => { this.error = true }
        );
    }

    //Upon component initialize, wire up event subscribers
    ngAfterContentChecked() {
        // componentHandler.upgradeAllRegistered();
    }
 
    // destroy map
    ngOnDestroy() {
    }

    getEarlyVotingInformation(){
        this.selectedAddressSuggestion ? this.selectedFullAddress = this.selectedAddressSuggestion["FullAddress"] : this.selectedFullAddress = "Address undefined";
        //get the early votiung location info
        this._electionService.getSatellites(this.selectedAddressLocation["X"], this.selectedAddressLocation["Y"])
            .then(satellites => {
                // satellites.forEach(satellite => {
                //     let busRoutes:String = (satellite.BusRoutes as Array<string>).join(", ");
                //     satellite.BusRoutes = busRoutes;
                // });
                this.satelliteLocations = satellites;
                this.satelliteName = satellites[0].Name;
                this.isEarlyVotingRetrieved = true;
                this._eventsService.setSatellites(satellites);
            }
        )
        .catch(error => {
            this.error = error
            console.log("Logging error: Cannot retrieve Early Voting Info." + this.error )
        });
    }

    //activate map panel and zoom to the polling place
    viewSatelliteOnMap (satelliteVotingLocation:Object) {
        this._eventsService.zoomToLocation(satelliteVotingLocation);
        this._eventsService.setActiveTab("tabMap");
    }

    //activate map panel and zoom to the satellite polling place
    getDrivingDirections (destination:string = "polling") {
        this._eventsService.getDirections(destination);
        this._eventsService.setActiveTab("tabMap");
    }

    //show/hide the share via email panel
    toggleEmailPanel (display:boolean, votingType:votingLocationType, satelliteVotingLocation:Object) {
        this.showEmailPanel = display;
        switch (votingType) {
            case "early-voting":
                this.showEmailPanel && satelliteVotingLocation ? this.shareSatellitePollingPlace(satelliteVotingLocation): null;
                break;
        }
    }

    //trigger the sharing of a polling place via email
    shareSatellitePollingPlace(satelliteVotingLocation:Object) {
        let forAddress:string;
        let pplHoursLabel:string;
        let ppNameLabel:string;
        let ppAddressLabel:string;
        let ppCityLabel:string;
        let accessibilityText:string 

        this._translate.get("pplTitle").subscribe(text => this.emailSubject = text );
        this._translate.get("emailForAddress").subscribe(text => forAddress = text );
        this._translate.get("pplAddress").subscribe(text => ppAddressLabel = text );
        this._translate.get("pplHours").subscribe(text => pplHoursLabel = text );
        this._translate.get("pplPollingPlace").subscribe(text => ppNameLabel = text );
        this._translate.get("pplCity").subscribe(text => ppCityLabel = text );
        this.emailSubject = "Early Voting Locations";

        this.emailBody = this.emailSubject + " " + forAddress + " " + this.selectedFullAddress + "<br/><br/>" +
                            satelliteVotingLocation["Name"] + "<br/><br/>" + ppAddressLabel + " " + satelliteVotingLocation["StreetAddress"] +
                            "<br/>" + ppCityLabel + " " + satelliteVotingLocation["City"] + "<br/>" + pplHoursLabel +
                            satelliteVotingLocation["Schedule"];
    }

     //view the full image in the larger modal dialog
     viewFullImage (photoURL:string) {
        let modal = document.getElementById('myEarlyVotingModal');
        modal.style.display = "block";
        this.activePhoto = photoURL;
    }
}


// WEBPACK FOOTER //
// ./app/information/earlyvoting/earlyvoting.component.ts